import { Grid } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { EmissionsGroupCard } from '../../../presentation-components/emissons-components/overview/emissions-display/emissions-group-card';
import { IconName } from '../../../../shared/interfaces/icon-picker.model';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container';
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading';
import { useContext } from 'react';
import { ScreenLabelsContext } from '../../../../context/screen-labels/screen-labels';

export const EmissionsSurveyPage = () => {
  const navigate = useNavigate();
  //Context
  const screenLabelsContext = useContext(ScreenLabelsContext)

  const clickEmployeeHandler = () => {
    navigate('/emissions/surveys/employee')
  }

  return (
    <PageOuterContainer>
      <PageHeading
        title={` Surveys `}
        hasTabs={false}
      />
      <Grid container spacing={4}>
        <Grid item lg={4} xs={12}>
          <EmissionsGroupCard
            icon={IconName.DirectionsWalk}
            title={'Employee Surveys'}
            description={'Collect data on your employees\' commuting habits to help calculate your organisations carbon emissions.'}
            clickHandler={clickEmployeeHandler}
            actionsTotal={0} />
        </Grid>
      </Grid>
    </PageOuterContainer>
  )
}